import { usePaymentFormContext } from '../context/PaymentFormContext';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
export const useCustomFormFields = () => {
  const {
    checkoutSession: checkoutSessionMap
  } = usePaymentFormContext();
  const checkoutSession = checkoutSessionMap.toJS();
  const customFormFields = checkoutSession.formFields.filter(field => field.name !== 'email').map(field => {
    field.label = propertyLabelTranslator(field.label);
    return field;
  });
  const orderedCustomFormFieldErrorKeys = customFormFields.reduce((acc, field) => {
    if (field.fieldType === 'phonenumber') {
      acc.push(`invalidPhoneNumber_${field.label}`, `empty${field.label}`);
    } else {
      acc.push(`empty${field.label}`);
    }
    return acc;
  }, []);
  return {
    customFormFields,
    orderedCustomFormFieldErrorKeys
  };
};